<template>
  <div class="main-wrapper">
    <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top" id="sideNav">
      <a class="navbar-brand js-scroll-trigger" href="#about">
        <span class="d-block d-lg-none">My Resume</span>
        <span class="d-none d-lg-block">
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            src="./assets/avatar.png"
            alt
          />
        </span>
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav">
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#about">About</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#experience">Experience</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#education">Education</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#skills">Skills</a>
          </li>
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#interests">Interests</a>
          </li>
          <!-- <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#awards">Awards</a>
          </li>-->
        </ul>
      </div>
    </nav>

    <div class="container-fluid p-0">
      <section class="resume-section p-3 p-lg-5 d-flex d-column" id="about">
        <div class="my-auto">
          <h1 class="mb-0">
            {{ name }}
            <span class="text-primary">{{ surname }}</span>
          </h1>
          <div class="subheading mb-5">
            {{ address }}
            <a :href="`mailto:${email}`">{{ email }}</a>
          </div>
          <p class="mb-5">{{ aboutMe }}</p>
          <ul class="list-inline list-social-icons mb-0">
            <li class="list-inline-item" style="font-size: 1rem !important">
              <a href="https://facebook.com/rodericksamuelhalim">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <li class="list-inline-item" style="font-size: 1rem !important">
              <a href="https://instagram.com/roderickhalim">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-instagram fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <li class="list-inline-item" style="font-size: 1rem !important">
              <a href="https://linkedin.com/in/roderick-samuel-halim-84b720118/">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-linkedin fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
            <li class="list-inline-item" style="font-size: 1rem !important">
              <a href="https://github.com/greekrode">
                <span class="fa-stack fa-lg">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-github fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="experience">
        <div class="my-auto">
          <h2 class="mb-5">Experience</h2>

          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="job in experience"
            :key="job.company"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{ job.position }}</h3>
              <div class="subheading mb-3">{{ job.company }}</div>
              <p>{{ job.description }}</p>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary">{{ job.startDate }} - {{ job.endDate }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="education">
        <div class="my-auto">
          <h2 class="mb-5">Education</h2>

          <div
            class="resume-item d-flex flex-column flex-md-row mb-5"
            v-for="study in education"
            :key="study.name"
          >
            <div class="resume-content mr-auto">
              <h3 class="mb-0">{{ study.name }}</h3>
              <div class="subheading mb-3">{{ study.degree }}</div>
              <div>{{ study.major }}</div>
              <p>{{ study.score }}</p>
            </div>
            <div class="resume-date text-md-right">
              <span class="text-primary">{{ study.startDate }} - {{ study.endDate }}</span>
            </div>
          </div>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="skills">
        <div class="my-auto">
          <h2 class="mb-5">Skills</h2>

          <div class="subheading mb-3">Programming Languages &amp; Tools</div>
          <ul class="list-inline list-icons">
            <li class="list-inline-item">
              <i class="devicons devicons-nodejs"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-react"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-java"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-ruby"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-laravel"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-symfony"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-postgresql"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-mysql"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-amazonwebservices"></i>
            </li>
            <li class="list-inline-item">
              <i class="devicons devicons-git"></i>
            </li>
          </ul>

          <div class="subheading mb-3">Workflow</div>
          <ul class="fa-ul mb-0">
            <li>
              <i class="fa-li fa fa-check"></i>
              Responsive Design
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Cross Browser Testing &amp; Debugging
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Cross Functional Teams
            </li>
            <li>
              <i class="fa-li fa fa-check"></i>
              Agile Development &amp; Scrum
            </li>
          </ul>
          <br />

          <div class="subheading mb-3">Language</div>
          <ul class="fa-ul mb-0">
            <li>
              <i class="fa-li fa fa-star"></i>
              Bahasa Indonesia
            </li>
            <li>
              <i class="fa-li fa fa-star"></i>
              English
            </li>
            <li>
              <i class="fa-li fa fa-star"></i>
              Chinese
            </li>
            <li>
              <i class="fa-li fa fa-star"></i>
              Korean
            </li>
          </ul>
        </div>
      </section>

      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="interests">
        <div class="my-auto">
          <h2 class="mb-5">Interests</h2>
          <p>Apart from being a web developer, I enjoy most of my time being playing guitar and game. I also like photography in which I take random photos wherever I am and edit it.</p>
          <p>Sometimes, I prefer to hang out such as going for a walk or grab a cup of coffee and have a chat with my friends.</p>
        </div>
      </section>

      <!-- <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="awards">
        <div class="my-auto">
          <h2 class="mb-5">Awards &amp; Certifications</h2>
          <ul class="fa-ul mb-0">
            <li>
              <i class="fa-li fa fa-trophy text-warning"></i>
              HSK (Chinese Proficiency Test) - Level 5
              </li>
          </ul>
        </div>
      </section>-->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      title: 'Roderick Halim | Resume',
      name: 'RODERICK SAMUEL',
      surname: 'HALIM',
      address: 'Jakarta, Indonesia',
      email: 'roderickhalim@gmail.com',
      aboutMe:
        'A software engineer focusing on web development. Eager to learn new technology and adapt with new environment. More towards back-end, but I do develop front-end as well.',
      experience: [
        {
          position: 'Sofwate Engineer (Fullstack)',
          company: 'MOKA (PT. Moka Teknologi Indonesia)',
          description:
            'Developing front-end with React + Redux-Saga. and developing back-end with SpringBoot(Java) and Rails(Ruby) together with PostgreSQL as database for a Point-of-Sales system. Daily task including fixing bugs and errors, optimize query performance and also create new feature as required.',
          startDate: 'July 2019',
          endDate: 'Present'
        },
        {
          position: 'Backend Web Developer',
          company: 'Paprika (PT. Paprika Multimedia)',
          description:
            'Create and maintain backend services for loyalty app. Using Symfony(PHP) and PostgreSQL for database. Develop RESTful API and also write Unit and Integration Test for API created.',
          startDate: 'September 2018',
          endDate: 'June 2019'
        },
        {
          position: 'Fullstack Web Developer',
          company: 'CV. RLSoft',
          description:
            'Create and maintain customize website such as e-commerce and ERP. E-commerce created for PT. Megah Modern Mandiri (M3) and ERP for PT. Mitra Winsy Indonesia.',
          startDate: 'December 2017',
          endDate: 'June 2018'
        },
        {
          position: 'SAP Technical Consultant Intern',
          company: 'Visi Intech (PT. Visi Anugrah Inti Teknologi)',
          description:
            'Create and maintain customization for SAP B1, including customize forms and reports and also Add-Ons. Mostly writing query for custom reports and also the design.',
          startDate: 'September 2017',
          endDate: 'November 2017'
        }
      ],
      education: [
        {
          name: 'Pelita Harapan University',
          degree: 'Bachelor of Computer Science',
          major: 'Information System · Web and Mobile Development',
          score: 'GPA: 3.6',
          startDate: 'August 2015',
          endDate: 'November 2019'
        },
        {
          name: 'SMAS Methodist-3',
          degree: 'Senior High School',
          major: 'Science Studies',
          startDate: 'June 2012',
          endDate: 'May 2015'
        }
      ]
    }
  },
  mounted () {
    const $ = this.jquery
    this.$nextTick(() => {
      // our custom jQuery code goes here
      $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
        if (
          location.pathname.replace(/^\//, '') ===
            this.pathname.replace(/^\//, '') &&
          location.hostname === this.hostname
        ) {
          var target = $(this.hash)
          target = target.length
            ? target
            : $('[name=' + this.hash.slice(1) + ']')
          if (target.length) {
            $('html, body').animate(
              {
                scrollTop: target.offset().top
              },
              1000,
              'easeInOutExpo'
            )
            return false
          }
        }
      })

      // Closes responsive menu when a scroll trigger link is clicked
      $('.js-scroll-trigger').click(function () {
        $('.navbar-collapse').collapse('hide')
      })

      // Activate scrollspy to add active class to navbar items on scroll
      $('body').scrollspy({
        target: '#sideNav'
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue